import PendingKyc from "./PendingKyc";

export default PendingKyc;
